
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { PasswordInput } from "./PasswordInput";

interface FormData {
  name: string;
  email: string;
  password: string;
}

interface SignUpFormFieldsProps {
  formData: FormData;
  setFormData: (data: FormData) => void;
  isTestMode: boolean;
  setIsTestMode: (value: boolean) => void;
  subscribeToNewsletter: boolean;
  setSubscribeToNewsletter: (value: boolean) => void;
}

export const SignUpFormFields = ({
  formData,
  setFormData,
  isTestMode,
  setIsTestMode,
  subscribeToNewsletter,
  setSubscribeToNewsletter,
}: SignUpFormFieldsProps) => {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="name">Name</Label>
        <Input
          id="name"
          type="text"
          placeholder="Enter your name"
          value={formData.name}
          onChange={(e) =>
            setFormData({ ...formData, name: e.target.value })
          }
          required
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          type="email"
          placeholder="Enter your email"
          value={formData.email}
          onChange={(e) =>
            setFormData({ ...formData, email: e.target.value })
          }
          required
        />
      </div>
      <PasswordInput 
        value={formData.password}
        onChange={(value) => setFormData({ ...formData, password: value })}
      />
      <div className="flex items-center space-x-2">
        <Switch
          id="test-mode"
          checked={isTestMode}
          onCheckedChange={setIsTestMode}
        />
        <Label htmlFor="test-mode">Enable Test Mode</Label>
      </div>
      <div className="flex items-center space-x-2">
        <Switch
          id="newsletter"
          checked={subscribeToNewsletter}
          onCheckedChange={setSubscribeToNewsletter}
        />
        <Label htmlFor="newsletter">Subscribe to newsletter</Label>
      </div>
    </div>
  );
};
